import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaeea40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-tasks me-2" }),
  /*#__PURE__*/_createTextVNode("การดำเนินการโครงการ")
], -1))
const _hoisted_4 = { class: "card-subtitle text-muted" }
const _hoisted_5 = { class: "card-body my-3" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "input-group mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle" })
], -1))
const _hoisted_14 = { class: "mb-3 text-primary" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cubes me-2" }, null, -1))
const _hoisted_16 = { class: "input-group mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search-dollar" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "ประเภทงบประมาณทั้งหมด", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("เกิดข้อผิดพลาด!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดหน้าที่รับผิดชอบก่อน")
], -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_ProjectProvinceSummaryComponent = _resolveComponent("ProjectProvinceSummaryComponent")!
  const _component_ProjectTableComponent = _resolveComponent("ProjectTableComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h6", _hoisted_4, "การรายงานข้อมูลผลการดำเนินการโครงการของ " + _toDisplayString(_ctx.role?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.assigned)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFiscalYear) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalYearChange && _ctx.fiscalYearChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: fiscalYear.id,
                              value: fiscalYear
                            }, _toDisplayString(fiscalYear.name), 9, _hoisted_10))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedFiscalYear]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_VueSelect, {
                          class: "form-control p-0",
                          modelValue: _ctx.selectedProvince,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedProvince) = $event)),
                          options: _ctx.provinces,
                          clearable: false,
                          label: "name",
                          placeholder: "กรุณาเลือกจังหวัด",
                          "onOption:selected": _cache[3] || (_cache[3] = () => _ctx.selectedBudgetType = 0)
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_ProjectProvinceSummaryComponent, {
                    "fiscal-year": _ctx.selectedFiscalYear,
                    province: _ctx.selectedProvince
                  }, null, 8, ["fiscal-year", "province"]),
                  _createElementVNode("h4", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode("โครงการของ " + _toDisplayString(_ctx.selectedProvince?.name !== 'กรุงเทพมหานคร' ? 'จ.': '') + _toDisplayString(_ctx.selectedProvince?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedBudgetType) = $event))
                    }, [
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.budgetTypes, (budgetType) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: budgetType.id,
                          value: budgetType.id
                        }, _toDisplayString(budgetType.name), 9, _hoisted_19))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedBudgetType]
                    ])
                  ]),
                  _createVNode(_component_ProjectTableComponent, {
                    "fiscal-year": _ctx.selectedFiscalYear,
                    province: _ctx.selectedProvince,
                    budgetTypeId: _ctx.selectedBudgetType
                  }, null, 8, ["fiscal-year", "province", "budgetTypeId"])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
          ], 64))
    ])
  ]))
}